import React from "react";
import { Navigate } from "react-router-dom";

const AuthProtected = (props) => {
  const authUser = localStorage.getItem("@token");
  console.log("user detected");
  if (!authUser) {
    return <Navigate to="/" />;
  }

  return <>{props.children}</>;
};

export { AuthProtected };
